import styled from 'styled-components';

export const FieldContainer = styled.div`
  margin-bottom: 20px;
`;

export const FrequencySelection = styled.div`
  display: flex;
`;

export const TextAddition = styled.span`
  margin: 0 15px;
`;
